// Light / dark mode. 'auto' follows the computer. The choice is kept on this computer.
const KEY = 'erp-theme'

export function getTheme() {
    try { return localStorage.getItem(KEY) || 'auto' } catch (e) { return 'auto' }
}

export function effectiveTheme(theme = getTheme()) {
    if (theme !== 'auto') return theme
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function applyTheme(theme = getTheme()) {
    const root = document.documentElement
    if (theme === 'auto') root.removeAttribute('data-theme')
    else root.setAttribute('data-theme', theme)
}

export function setTheme(theme) {
    try { localStorage.setItem(KEY, theme) } catch (e) { /* storage blocked */ }
    applyTheme(theme)
    window.dispatchEvent(new Event('erp-theme'))
}
